import { css } from "styled-components";

export const stylesWrapperWithoutCentring = css`
  width: 90%;
  max-width: 1400px;
`;

export const stylesWrapper = css`
  ${stylesWrapperWithoutCentring};
  margin-left: auto;
  margin-right: auto;
`;

export const wysiwygStyles = css`
  line-height: 1.6;

  a {
    color: ${({ theme }) => theme.primary};
    text-decoration: none;

    :hover {
      text-decoration: underline;
    }

    > span {
      color: ${({ theme }) => theme.primary}!important;
    }
  }

  strong {
    font-weight: 600;
  }
`;
